// Force rebuild to pick up new env variables
const isDevelopment = process.env.NODE_ENV === 'development';

const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  },
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL,
    key: process.env.REACT_APP_SUPABASE_KEY,
  },
  endpoints: {
    chat: '/api/chat',
    auth: '/auth',
    settings: '/api/settings',
    leads: '/api/leads',
    userInfo: '/auth/userinfo',
    systemPrompt: '/api/settings/system-prompt',
    vectorStore: '/api/settings/vector-store',
    conversations: '/api/conversations',
    'vector-classifier-prompt': '/api/settings/vector-classifier-prompt',
    'vector-classifier-threshold': '/api/settings/vector-classifier-threshold',
    'product-classifier-prompt': '/api/settings/product-classifier-prompt',
    'product-classifier-threshold': '/api/settings/product-classifier-threshold',
    'system-prompt': '/api/settings/system-prompt',
    'vector-store-prompt': '/api/settings/vector-store-prompt',
    'assistant-id': '/api/settings/assistant-id',
    'vectorstore-id': '/api/settings/vectorstore-id'
  }
};

export default config;
